import React from 'react';

import { Popover, PopoverPanel, Transition } from '@headlessui/react';

type Props = {
    children: React.ReactNode;
    open: boolean;
    popoverClass?: string;
    translationX?: number;
    translationY?: number;
};

const ControlledTooltip = ({ children, open, popoverClass, translationX = 0, translationY = 0 }: Props) => {
    return (
        <Popover
            className={popoverClass}
            style={{ position: 'absolute', translate: `${translationX}px ${translationY}px`, zIndex: 1000 }}
        >
            <Transition
                show={open}
                as="div"
                enter="absolute transition ease-out duration-200 transform"
                enterFrom="absolute opacity-0 translate-y-0"
                enterTo="w-full opacity-100 translate-y-0"
                leave="absolute w-full transition ease-out duration-200"
                leaveFrom="absolute w-full opacity-100"
                leaveTo="w-full opacity-0"
            >
                <PopoverPanel className="absolute hover:cursor-default">
                    <>{children}</>
                </PopoverPanel>
            </Transition>
        </Popover>
    );
};

export default ControlledTooltip;
